import intl from "react-intl-universal";
import ptBrJson from "../Locales/pt-BR.json";
import enUsJson from "../Locales/en-US.json";
import esEsJson from "../Locales/es-ES.json";
import arAeJson from "../Locales/ar-AE.json";
import { loadItem } from "./sessionStorage";

export const LOCALE_STORAGE_KEY = "userLanguage";

const userLanguage = loadItem(LOCALE_STORAGE_KEY);

const supportedLocales = ["pt-BR", "en-US", "es-ES", "ar-AE"];

const locales = {
  "pt-BR": ptBrJson,
  "en-US": enUsJson,
  "es-ES": esEsJson,
  "ar-AE": arAeJson,
};

const loadLocales = () => {
  let currentLocale;

  if (userLanguage) {
    currentLocale = userLanguage;
  } else {
    currentLocale = intl.determineLocale({
      urlLocaleKey: "lang",
      cookieLocaleKey: "lang",
    });

    if (!supportedLocales.find((language) => language === currentLocale)) {
      currentLocale = "pt-BR";
    }
  }

  return currentLocale;
};

const updateLocales = (language) => {
  let currentLocale = intl.getInitOptions();
  currentLocale = currentLocale.currentLocale;

  if (!language) {
    currentLocale = intl.determineLocale({
      urlLocaleKey: "lang",
      cookieLocaleKey: "lang",
    });
  }

  if (supportedLocales.find((value) => value === language)) {
    currentLocale = language;
  }

  return currentLocale;
};

export { locales, loadLocales, updateLocales, supportedLocales };
